import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";
import React from "react";

const BoxProgress = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export default function FormProgress() {
  return (
    <BoxProgress>
      <CircularProgress />
    </BoxProgress>
  );
}
